export const CLIENT_TELLING_SEARCH_CONTACT_INIT_PAGE = 1;

export const CLIENT_TELLING_SEARCH_CONTACT_PAGESZ = 10;
